import OrderSummaryRow from 'common/OrderSummary/components/OrderSummaryRow';
import { PlasticBagPackingInfo } from 'network/response/ICart';

import * as S from './PackingFeeRow.style';

const PackingFeeRow: React.FC<{
  plasticBagPackingInfo?: PlasticBagPackingInfo;
  label: string;
  sustainabilityConsent: boolean | null;
}> = ({ plasticBagPackingInfo, label, sustainabilityConsent }) => {
  const isPackingChargeApplicable = sustainabilityConsent !== null;

  return isPackingChargeApplicable && plasticBagPackingInfo && plasticBagPackingInfo.calculated ? (
    <OrderSummaryRow
      label={
        <>
          {label}
          {plasticBagPackingInfo.quantity > 0 && (
            <S.PlasticBagQty as="span">({plasticBagPackingInfo.quantity})</S.PlasticBagQty>
          )}
        </>
      }
      priceDetails={plasticBagPackingInfo.totalCharges || {}}
      testId="packing-fee"
    />
  ) : (
    <></>
  );
};

export default PackingFeeRow;
